<template>
    <aside id="chat-side-panel" :class="['theme-' + selectedTheme, {'rolled-out': isRolledOut}]">
        <div>
            <div id="logo-container">
                <i class="fa fa-bars toggle-side-panel" @click="toggleRollOut()"></i>
                <div id="logo"><img src="/static/mixsii-logo.svg"/></div>
            </div>

            <logged-details></logged-details>
        </div>
        <div>
            <online-users></online-users>
        </div>
    </aside>
</template>

<script>

    import LoggedDetails from './ChatSidePanelWidgets/LoggedDetails.vue';
    import OnlineUsers from './ChatSidePanelWidgets/OnlineUsers.vue';
    import UserChats from './ChatSidePanelWidgets/UserChats.vue';
    import GroupDetails from './ChatSidePanelWidgets/GroupDetails.vue';

    export default {
        name: 'ChatSidePanel',
        components: {
            'logged-details': LoggedDetails,
            'online-users': OnlineUsers,
            'user-chats': UserChats,
            'group-details': GroupDetails
        },

        data(){
            return {
                fullSidePanelMode: false
            }
        },

        computed: {
            activeChatId(){
                return this.$store.state.activeChatModel.id;
            },

            activeChatType(){
                return !this.activeChatId ? '' : this.activeChatId.split('.')[0];
            },

            selectedTheme(){
                return this.$store.state.loggedUserModel.info.theme
            },

            isRolledOut(){
            	return this.$store.state.chatroomConfigModel.fullSidePanelMode;
            }
        },

        methods: {
			toggleRollOut(){
				this.$store.dispatch('chatroomConfigModel/setFullSidePanelMode', !this.isRolledOut);
            }
        },

        watch: {
            '$store.state.activeChatModel.id'(){
                this.fullSidePanelMode = false;
            }
        }

    }
</script>


// WEBPACK FOOTER //
// ChatSidePanel.vue?627728b4